export enum UserManagementRoles {
  Admin = 'admin',
  Backoffice = 'backoffice',
  Marketing = 'marketing',
  Onboarding = 'onboarding',
  SalesQA = 'sales_qa',
  Support = 'support',
}
